export const Env = {
  API_URL: process.env.REACT_APP_API_URL || 'https://my.houstonproperties.com/api/home-search',
  PUBLIC_ID: process.env.REACT_APP_PUBLIC_ID || '55156FEv',
  GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY,
};
